export const removeEmptyRowsFromString = (urlString) =>
  urlString.split('\n').filter((item) => item);
